export default "<div id=\"overlay\">\n\t<app-inputs id=\"inputs\"></app-inputs>\n\t<app-console id=\"console\"></app-console>\n</div>\n";